
define('text!templates/modules/setting/business/modals/payment-expired-group-modal.html',[],function () { return '<p>\n    {{#canManagePayments}}\n        {{#t}}payment:expired_group_admin_message{{/t}}\n    {{/canManagePayments}}\n    {{^canManagePayments}}\n        {{#t}}payment:expired_group_member_message{{/t}}\n    {{/canManagePayments}}\n</p>\n';});

